import AsyncStorage from "@react-native-async-storage/async-storage";

const persistAuthConfig = {
  key: "auth",
  storage: AsyncStorage,
};

export default persistAuthConfig;
